import config from 'config';

export type DocumentPdfKind = 'signed' | 'unsigned';

/** App-mediated PDF download (ENG-2627): a plain navigation so the session cookie travels with it. */
export const documentDownloadUrl = (documentId: string, kind: DocumentPdfKind = 'signed'): string =>
  `${config.API_SERVER}/documents/${documentId}/download/?kind=${kind}`;

export const openDocumentDownload = (documentId: string, kind: DocumentPdfKind = 'signed'): void => {
  const link = document.createElement('a');
  link.href = documentDownloadUrl(documentId, kind);
  link.click();
};
